import axios from "axios"
import {Promotion} from "../../Model/Sales/Promotion";
import {isRequestError, RequestError} from "../../Model/RequestError";
import {acceptHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import {joinUrl} from "../../Utilities/UriUtilities";
import {Reseller} from "../../Types/Reseller";
import {ContentType} from "../../Model/Sales/ContentType";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";
import {CmsContent} from "../../Model/CmsContent/CmsContent";

/**
 * Function is responsible for fetching a single valid promotion
 * with the given promotion code.
 */

export const fetchPromo = async (
    reseller: Reseller,
    domain: string,
    promoCode: string
): Promise<Promotion | RequestError> => {
    const endpoint = joinUrl(domain, `/${reseller}/promo/${promoCode}/view`)
    const headers = acceptHeader()

    const response = await executeWithErrorResponseHandling<Promotion>(() =>
        axios.get(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/promo/{promoCode}/view", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/promo/{promoCode}/view", "status": "success"}})
        return response.data
    }
}

export const fetchAvailablePromotionCardContent = async (
    domain: string,
    reseller: Reseller,
    contentType: ContentType,
): Promise<any> => {
    const endPoint = joinUrl(domain, `/${reseller}/promo/cardContent/${contentType}`)
    const headers = acceptHeader()

    const response = await executeWithErrorResponseHandling<any>(() =>
        axios.get(endPoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/promo/cardContent/{contentType}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/promo/cardContent/{contentType}", "status": "success"}})
        return response.data
    }
}

/**
 * Fetches the HTML content for a plan card
 */
export const fetchPromoPlanCardContent = async (
    domain: string,
    contentType: ContentType,
    planCode: string,
    promoCode: string
): Promise<any> => {
    const endpoint = joinUrl(domain, `superdrug/content/plan/${planCode}/promo/${promoCode}/contentType/${contentType}`)
    const headers = {"Accept": "application/json"}

    const response = await executeWithErrorResponseHandling<any>(() =>
        axios.get<CmsContent[]>(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "content/plan/{planCode}/promo/{promoCode}/type/{contentType}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "content/plan/{planCode}/promo/{promoCode}/type/{contentType}", "status": "success"}})
        return response.data
    }
}